import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Buffer } from "buffer";
import "@rainbow-me/rainbowkit/styles.css";
import "./styles/cyfonii-base.css";
import "./styles/cyfonii/style.css";
import "./styles/cyfonii/app.css";
import "./styles/nav.css";
import "./styles/global-text.css";
import "./styles/smooth-scroll.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "aos/dist/aos.css";
import { WagmiProvider } from "wagmi";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { RainbowKitProvider } from "@rainbow-me/rainbowkit";
import { config } from "./config/rainbowkit";
import Home from "./pages/Home";
import NoPage from "./pages/NoPage";
import WalletChecker from "./pages/WalletChecker";
import Mint from "./pages/Mint";
import About from "./pages/About";
import Collection from "./pages/Collection";
import Mission from "./pages/Mission";
import FreeMint from "./pages/FreeMint";
import Setting from "./pages/Setting";
import SnowEffect from "./components/SnowEffect";

window.Buffer = window.Buffer || Buffer;

const queryClient = new QueryClient();

export default function App() {
  return (
    <StrictMode>
      <WagmiProvider config={config}>
        <QueryClientProvider client={queryClient}>
          <RainbowKitProvider>
            <BrowserRouter>
              <SnowEffect />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/collection" element={<Collection />} />
                <Route path="/wallet-checker" element={<WalletChecker />} />
                <Route path="/mission" element={<Mission />} />
                <Route path="/free-mint" element={<FreeMint />} />
                <Route path="/mint" element={<Mint />} />
                <Route path="/setting" element={<Setting />} />
                <Route path="*" element={<NoPage />} />
              </Routes>
            </BrowserRouter>
          </RainbowKitProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </StrictMode>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
